/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { useEffect, useState } from 'react';
import { Card, PanelStack, Toaster, Position, Intent } from '@blueprintjs/core';
import { DataImport } from './DataImport';
import { selectDIL, DILList, DIL } from 'srs-middleware';
import { SidePanel } from './sidePanel';
import { SchemaEditor } from './schemaEditor';
import { DefinitionProps } from './interfaces';
import { colors } from './styles';
import { DatasetManagementContext } from './datasetManagementContext';

export const DatasetManagement = ({ explorerCallback }) => {
	const [dilList, setDilList] = useState<DILList>(selectDIL());

	// need to update dillist deletion or addition
	const [selectedPanelDil, setSelectedPanelDil] = useState<DIL>();

	const [needUpdate, setNeedUpdate] = useState(false);
	const [unsavedChanges, setUnsavedChanges] = useState(false);

	const onComplete = () => {
		AppToaster.show({
			icon: 'tick-circle',
			message: 'Saved',
			intent: Intent.SUCCESS,
		});

		window.location.reload(false);
	};

	useEffect(() => {
		//refreshDIL(); // uncomment when refreshDil gets pushed merged into srs-middleware master and is re-packaged
		setDilList(selectDIL());
	}, [needUpdate]);

	const providerValues = {
		dilList,
		selectedPanelDil,
		setSelectedPanelDil,
		toaster: AppToaster,
		setNeedUpdate,
		explorerCallback,
		unsavedChanges,
		setUnsavedChanges,
	};

	return (
		<DatasetManagementContext.Provider value={providerValues}>
			<div css={container}>
				<Card css={panelWrapper}>
					<PanelStack
						initialPanel={{
							component: SidePanel,
							title: 'Manage Datasets',
						}}
						renderActivePanelOnly={true}
						showPanelHeader={false}
					/>
				</Card>
				<Card cy-test="widget-card" css={viewWrapper}>
					{selectedPanelDil ? (
						<div css={schemaEditorStyle}>
							<SchemaEditor
								colors={colors}
								dil={selectedPanelDil as DefinitionProps}
								setDil={setSelectedPanelDil}
								onComplete={onComplete}
							/>
						</div>
					) : (
						<DataImport />
					)}
				</Card>
			</div>
		</DatasetManagementContext.Provider>
	);
};

const AppToaster = Toaster.create({
	className: 'recipe-toaster',
	position: Position.TOP,
});

const container = css`
	flex: 1 1 auto;
	overflow: hidden;
	display: grid;
	grid-template-columns: 300px 1fr;
	grid-template-rows: 1fr;
	grid-gap: 6px;
	padding: 6px;
`;
const schemaEditorStyle = css`
	padding: 16px 40px 8px 40px;
	height: 100%;
`;
const panelWrapper = css`
	padding: 0;
	.bp3-panel-stack {
		height: 100%;
		border-radius: 3px;
	}
`;
const viewWrapper = css`
	overflow: hidden;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: stretch;
	padding: 10px;
`;
